import { ICombinedUserData } from 'lib/context';

// Vin Reels
export const checkIfVinReelsEnabled = (userData: ICombinedUserData) => {
  return !!Number(userData?.customer?.isUsingVinReels);
};
// AI Spotlight
export const checkIfAISpotlightEnabledForUser = (
  userData: ICombinedUserData
) => {
  return (
    !!Number(userData?.customer?.spotlightEnabled) &&
    !!Number(userData?.spotlightEnabled)
  );
};
export const checkIfAISpotlightEnabledForCustomer = (
  userData: ICombinedUserData
) => {
  return !!Number(userData?.customer?.spotlightEnabled);
};
// Quick Videos
export const checkIfQuickVideosEnabled = (userData: ICombinedUserData) => {
  return !!Number(userData?.customer?.quickVideosEnabled);
};
// Suggested Content
export const checkIfSuggestedContentEnabled = (userData: ICombinedUserData) => {
  return !!Number(userData?.customer?.suggestedContentEnabled);
};
// AI Assistant
export const checkIfQuickVideoAvatarEnabledForUser = (
  userData: ICombinedUserData
) => {
  return (
    !!Number(userData?.customer?.quickVideoAvatarEnabled) &&
    !!Number(userData?.quickVideoAvatarEnabled)
  );
};
export const checkIfQuickVideoAvatarEnabledForCustomer = (
  userData: ICombinedUserData
) => {
  return !!Number(userData?.customer?.quickVideoAvatarEnabled);
};
